export const environment = {
    production: true,
    
    serviceBaseUrl: 'https://apigw.etfr.eurofins.com/facturesapaveprodserver/',
    launcherUrl: 'https://launcher.etfr.eurofins.com/',
 
    appName: 'ShareyourPO',
    appCode: 'APP0000075',
    name: 'PROD',
    edmUrl: '',
    //TokenAuthorization:'0317d4ac-1b12-4743-8ba3-8bd97ae06407',
    isMel : false,
};
